import BaseModelAPI from '../BaseModelAPI'

export default class VersionNotification extends BaseModelAPI {
  static entity = 'versionnotification'
  static entityName = 'versionnotification'
  constructor() {
    super()
    this.id = null
    this.platform = 'android'
    this.version = ''
    this.mode = 'Optional'
    this.titleNotification = ''
    this.playStoreUrl = ''
    this.appStoreUrl = ''
    this.messageNotification = ''
    this.storeButtonLabel = ''
    this.dismissButtonLabel = ''
    this.closeButtonLabel = ''
  }

  static async createData(context, data) {
    return (await this.getHttp(context).post(this.entityName, data)).data
  }
  static async updateData(context, data, id) {
    return (await this.getHttp(context).put(`${this.entityName}/${id}`, data)).data
  }

  // Online requests only. Detect the HTTP plugin's resolved-error behavior.
  static getHttp(context) {
    const request = async (method, url, data) => {
      const config = { timeout: 15000, headers: { 'X-App-SkipInterceptor': '1' } }
      const response = await (['get', 'delete'].includes(method)
        ? context.$http[method](url, config) : context.$http[method](url, data, config))
      if (!response || response.status < 200 || response.status >= 300 || !response.status) throw response || new Error('Server tidak merespons.')
      return response
    }
    return {
      get: url => request('get', url), delete: url => request('delete', url),
      post: (url, data) => request('post', url, data), put: (url, data) => request('put', url, data)
    }
  }
}
